export default {

    "selectAppItemTranslation" : "/backstageApi/AppItemTranslation/selectAppItemTranslation", // app 项目翻译 分页
    "saveAppItemTranslation" : "/backstageApi/AppItemTranslation/saveAppItemTranslation", // app 项目翻译 新增
    "updateAppItemTranslation" : "/backstageApi/AppItemTranslation/updateAppItemTranslation", // app 项目翻译 更新
    "selectAppLanguageTranslationPage" : "/backstageApi/AppItemTranslation/selectAppLanguageTranslationPage", // app 项目翻译详情 分页
    "appLanguageTranslationExportFile" : "/backstageApi/AppItemTranslation/exportFile", // app 项目翻译详情 导出翻译
    "deleteTranslation" : "/backstageApi/AppItemTranslation/deleteTranslation", // app 项目翻译详情 删除



}


// WEBPACK FOOTER //
// ./src/api/translation/translation.js